import Welcome from './pages/Welcome';
import EmployeeDashboard from './pages/EmployeeDashboard';
import BenefitsCatalog from './pages/BenefitsCatalog';
import BenefitDetail from './pages/BenefitDetail';
import EmployeeProfile from './pages/EmployeeProfile';
import AccountSettings from './pages/AccountSettings';
import Enrollment from './pages/Enrollment';
import MyBenefits from './pages/MyBenefits';
import Help from './pages/Help';
import AdminDashboard from './pages/AdminDashboard';
import EmployeeManagement from './pages/EmployeeManagement';
import EmployeeDetail from './pages/EmployeeDetail';
import BenefitsManagement from './pages/BenefitsManagement';
import CensusUpload from './pages/CensusUpload';
import Proposals from './pages/Proposals';
import ProposalPublic from './pages/ProposalPublic';
import Employers from './pages/Employers';
import EmployerDetail from './pages/EmployerDetail';
import Categories from './pages/Categories';
import EnrollmentReports from './pages/EnrollmentReports';
import AuditLog from './pages/AuditLog';
import EmployerDashboard from './pages/EmployerDashboard';
import ExportCensus from './pages/ExportCensus';
import Analytics from './pages/Analytics';
import SubAdminManagement from './pages/SubAdminManagement';
import AdminSettings from './pages/AdminSettings';
import AdminUpdates from './pages/AdminUpdates';
import EmployerEmployees from './pages/EmployerEmployees';
import EmployerEnrollments from './pages/EmployerEnrollments';
import Home from './pages/Home';
import SetupTestUsers from './pages/SetupTestUsers';
import FlexOptimization from './pages/FlexOptimization';
import FamilyMembers from './pages/FamilyMembers';
import Claims from './pages/Claims';
import ClaimsManagement from './pages/ClaimsManagement';
import ClaimDetail from './pages/ClaimDetail';
import TaxRateManagement from './pages/TaxRateManagement';
import EnrollmentPeriods from './pages/EnrollmentPeriods';
import QualifyingLifeEvents from './pages/QualifyingLifeEvents';
import W4Form from './pages/W4Form';
import PayrollReports from './pages/PayrollReports';
import DemographicReports from './pages/DemographicReports';
import TaxSavingsReports from './pages/TaxSavingsReports';
import MigrationsManagement from './pages/MigrationsManagement';
import PenetrationReports from './pages/PenetrationReports';
import TwoFactorAuth from './pages/TwoFactorAuth';
import RatingTables from './pages/RatingTables';
import SystemConfiguration from './pages/SystemConfiguration';
import EmailTemplates from './pages/EmailTemplates';
import InviteCodeEntry from './pages/InviteCodeEntry';
import EnrollmentIntro from './pages/EnrollmentIntro';
import EnrollmentReview from './pages/EnrollmentReview';
import EnrollmentSign from './pages/EnrollmentSign';
import CompanyOnboarding from './pages/CompanyOnboarding';
import CompanySettings from './pages/CompanySettings';
import HRManagers from './pages/HRManagers';
import Invite from './pages/Invite';
import CompanySignup from './pages/CompanySignup';
import RoleSelection from './pages/RoleSelection';
import EmployeeOnboarding from './pages/EmployeeOnboarding';
import Login from './pages/Login';
import Me from './pages/Me';
import Hr from './pages/Hr';
import Why from './pages/Why';
import MaintenanceMode from './pages/MaintenanceMode';
import __Layout from './Layout.jsx';


export const PAGES = {
    "Welcome": Welcome,
    "Login": Login,
    "MaintenanceMode": MaintenanceMode,
    "me": Me,
    "hr": Hr,
    "why": Why,
    "EmployeeDashboard": EmployeeDashboard,
    "BenefitsCatalog": BenefitsCatalog,
    "BenefitDetail": BenefitDetail,
    "EmployeeProfile": EmployeeProfile,
    "AccountSettings": AccountSettings,
    "Enrollment": Enrollment,
    "MyBenefits": MyBenefits,
    "Help": Help,
    "AdminDashboard": AdminDashboard,
    "EmployeeManagement": EmployeeManagement,
    "EmployeeDetail/:employeeId": EmployeeDetail,
    "BenefitsManagement": BenefitsManagement,
    "CensusUpload": CensusUpload,
    "Proposals": Proposals,
    "proposal/:token": ProposalPublic,
    "Employers": Employers,
    "EmployerDetail/:employerId": EmployerDetail,
    "Categories": Categories,
    "EnrollmentReports": EnrollmentReports,
    "AuditLog": AuditLog,
    "EmployerDashboard": EmployerDashboard,
    "ExportCensus": ExportCensus,
    "Analytics": Analytics,
    "SubAdminManagement": SubAdminManagement,
    "AdminSettings": AdminSettings,
    "AdminUpdates": AdminUpdates,
    "EmployerEmployees": EmployerEmployees,
    "EmployerEnrollments": EmployerEnrollments,
    "Home": Home,
    "SetupTestUsers": SetupTestUsers,
    "FlexOptimization": FlexOptimization,
    "FamilyMembers": FamilyMembers,
    "Claims": Claims,
    "ClaimsManagement": ClaimsManagement,
    "ClaimDetail/:claimId": ClaimDetail,
    "TaxRateManagement": TaxRateManagement,
    "EnrollmentPeriods": EnrollmentPeriods,
    "QualifyingLifeEvents": QualifyingLifeEvents,
    "W4Form": W4Form,
    "PayrollReports": PayrollReports,
    "DemographicReports": DemographicReports,
    "TaxSavingsReports": TaxSavingsReports,
    "PenetrationReports": PenetrationReports,
    "MigrationsManagement": MigrationsManagement,
    "TwoFactorAuth": TwoFactorAuth,
    "RatingTables": RatingTables,
    "SystemConfiguration": SystemConfiguration,
    "EmailTemplates": EmailTemplates,
    "InviteCodeEntry": InviteCodeEntry,
    "EnrollmentIntro": EnrollmentIntro,
    "EnrollmentReview": EnrollmentReview,
    "EnrollmentSign": EnrollmentSign,
    "CompanyOnboarding": CompanyOnboarding,
    "CompanySettings": CompanySettings,
    "HRManagers": HRManagers,
    "Invite": Invite,
    "CompanySignup": CompanySignup,
    "RoleSelection": RoleSelection,
    "EmployeeOnboarding": EmployeeOnboarding,
}

export const pagesConfig = {
    mainPage: "Welcome",
    Pages: PAGES,
    Layout: __Layout,
};